import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const DashboardRouter = () => {
  const { user, userRole, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      const role = String(userRole || '');
      if (role === '4') {
        navigate('/admin', { replace: true });
      } else {
        navigate('/welcome', { replace: true });
      }
    } else if (!loading && !user) {
      navigate('/sign-in', { replace: true });
    }
  }, [user, userRole, loading, navigate]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#fff' }}>
        Loading...
      </div>
    );
  }

  return null;
};

export default DashboardRouter;
